export const documentSerialMaskOptions = {
  mask: 'xxxx',
  replacement: { x: /\d/ },
};

export const documentNumberMaskOptions = {
  mask: 'xxx xxx',
  replacement: { x: /\d/ },
};

export const innMaskOptions = {
  mask: 'xxxxxxxxxxxx',
  replacement: { x: /\d/ },
};

export const phoneMaskOptions = {
  mask: '+7 ___ ___ __ __',
  replacement: { _: /\d/ },
};
